import { PermutatorService } from '../permutator'
import { Widget } from './WidgetInterface'
import { WidgetService } from './WidgetService'
import { WidgetType } from './WidgetTypes'

export default class WidgetFactory {
  public static create(widgetType: WidgetType): Widget | null {
    let widget = WidgetService.getWidgetSpecification(widgetType)

    if (!widget) return null

    // deep copy widget
    widget = JSON.parse(JSON.stringify(widget))
    widget.wbUUID = PermutatorService.uuid()
    widget.size = widget.size || widget.defaultSize || widget.minSize || 1
    widget.sortindex = 0

    return widget
  }
}
